import { createAction, createReducer } from '@reduxjs/toolkit';

const ON_DATA = createAction('rpmAccountData/onData');
const START_LOADING = createAction('rpmAccountData/startLoading');
const FINISH_LOADING = createAction('rpmAccountData/finishLoading');

export const actions = {
  ON_DATA,
  START_LOADING,
  FINISH_LOADING,
};

function startLoading(prev) {
  return { ...prev, loading: true };
}

function finishLoading(prev) {
  return { ...prev, loading: false };
}

function onData(prev, action) {
  return { ...prev, loading: false, data: action.payload };
}

const reducer = createReducer(
  {
    loading: false,
    data: null,
  },
  {
    [ON_DATA]: onData,
    [START_LOADING]: startLoading,
    [FINISH_LOADING]: finishLoading,
  }
);

export default reducer;
